module.exports = __webpack_public_path__ + "images/twitter_icon.1b0db601.webp";